export default __webpack_public_path__ + "images/4X.27b6cba.png";